export default "__VITE_ASSET__CNbv5OBM__"